import { CheckCircle2 } from "lucide-react";
import { EnquiryForm } from "../components/EnquiryForm";

const POINTS = [
  "One integrated team — strategy, creative, production, technology and execution",
  "Corporate events, launches, offsites, live shows, sports and hybrid experiences",
  "Technology-driven planning with digital registration, event apps and analytics",
];

const PlanEvent = () => (
  <main data-testid="plan-event-page">
    <section className="relative py-24 bg-[#00142D] overflow-hidden">
      <div className="absolute -top-32 right-0 w-[420px] h-[420px] rounded-full bg-[#1679B5]/25 blur-[110px]" />
      <div className="absolute -bottom-32 left-0 w-[380px] h-[380px] rounded-full bg-[#6FAF2D]/10 blur-[110px]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-[#32B5E8] mb-4">Plan Your Event</p>
        <h1 data-testid="plan-event-heading" className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight max-w-3xl">
          Tell us your brief. <span className="ev-gradient-text">We'll craft the concept.</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">
          Share a few details about your event and the Evontra team will come back with a tailored plan, format and estimate.
        </p>
      </div>
    </section>

    <section className="py-20 ev-grid-bg">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-5 gap-12 items-start">
        <div className="lg:col-span-2">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[#081D35] tracking-tight">Why plan with Evontra</h2>
          <ul className="mt-7 space-y-5">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-[#475569] leading-relaxed">
                <CheckCircle2 size={18} className="text-[#6FAF2D] shrink-0 mt-0.5" /> {p}
              </li>
            ))}
          </ul>
          <div className="mt-9 rounded-2xl bg-[#081D35] p-6 text-white">
            <p className="text-[11px] font-extrabold tracking-[0.18em] uppercase text-[#32B5E8] mb-2">Prefer to talk?</p>
            <p className="text-sm text-slate-300">Call us on <a href="tel:+919836372200" className="font-bold text-white hover:text-[#32B5E8] transition-colors">+91 98363 72200</a> or write to <a href="mailto:enquiry@evontra.co.in" className="font-bold text-white hover:text-[#32B5E8] transition-colors">enquiry@evontra.co.in</a></p>
          </div>
        </div>
        <div className="lg:col-span-3 rounded-3xl bg-white border border-slate-200 shadow-[0_30px_60px_-30px_rgba(8,29,53,0.25)] p-7 sm:p-9">
          <h2 className="text-xl font-extrabold text-[#081D35] mb-6">Plan Your Event</h2>
          <EnquiryForm />
        </div>
      </div>
    </section>
  </main>
);

export default PlanEvent;
